// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__2YdOf","list":"styles_list__3z9kT"};